(function () {
  if (customElements.get('cart-drawer-related')) return;

  function toCents(value) {
    if (typeof value === 'string' && value.indexOf('.') !== -1) {
      return Math.round(parseFloat(value) * 100);
    }
    return Number(value) || 0;
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
    } catch (error) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function parseExcludeIds(value) {
    return new Set(
      String(value || '')
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean)
    );
  }

  function pickVariant(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var available = variants.find(function (variant) {
      return variant && variant.available !== false;
    });
    return available || variants[0] || null;
  }

  function imageUrl(product) {
    if (!product) return '';
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    if (product.images && product.images[0]) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src || '';
    }
    return '';
  }

  function isAvailable(product) {
    if (!product || product.available === false) return false;
    if (product.available === true) return true;
    var variant = pickVariant(product);
    return Boolean(variant && variant.available !== false);
  }

  class CartDrawerRelated extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.list = this.querySelector('[data-related-list]');
      this.load();
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
    }

    load() {
      var productId = this.dataset.productId;
      var limit = Math.max(1, Math.min(6, Number(this.dataset.limit) || 3));
      var exclude = parseExcludeIds(this.dataset.excludeIds);
      if (!productId || !this.list) return;

      this.abortController = new AbortController();
      var url =
        '/recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        (limit + 8) +
        '&intent=related';

      fetch(url, { headers: { Accept: 'application/json' }, signal: this.abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('related');
          return response.json();
        })
        .then(
          function (data) {
            var products = (data.products || [])
              .filter(function (product) {
                return product && !exclude.has(String(product.id)) && isAvailable(product);
              })
              .slice(0, limit);
            if (!products.length) {
              this.remove();
              return;
            }
            this.render(products);
            this.hidden = false;
          }.bind(this)
        )
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
        });
    }

    render(products) {
      var addLabel = this.dataset.addLabel || 'Adicionar';
      var chooseLabel = this.dataset.chooseLabel || 'Ver';
      var fragment = document.createDocumentFragment();

      products.forEach(
        function (product) {
          var variant = pickVariant(product);
          var hasOnlyDefault =
            product.has_only_default_variant === true ||
            (Array.isArray(product.variants) && product.variants.length <= 1);
          var canQuickAdd = Boolean(variant && variant.id && variant.available !== false && hasOnlyDefault);

          var item = document.createElement('li');
          item.className = 'cart-drawer-related__item';

          var media = document.createElement('a');
          media.className = 'cart-drawer-related__media';
          media.href = product.url || '/products/' + product.handle;
          media.setAttribute('tabindex', '-1');
          media.setAttribute('aria-hidden', 'true');
          var src = imageUrl(product);
          if (src) {
            var img = document.createElement('img');
            img.src = src.indexOf('?') === -1 ? src + '?width=112' : src + '&width=112';
            img.alt = '';
            img.width = 56;
            img.height = 56;
            img.loading = 'lazy';
            media.appendChild(img);
          }

          var info = document.createElement('div');
          info.className = 'cart-drawer-related__info';

          var name = document.createElement('a');
          name.className = 'cart-drawer-related__name';
          name.href = product.url || '/products/' + product.handle;
          name.textContent = product.title || '';

          var price = document.createElement('div');
          price.className = 'cart-drawer-related__price';
          var priceCents = toCents(variant && variant.price != null ? variant.price : product.price);
          var compareCents = toCents(
            variant && variant.compare_at_price != null ? variant.compare_at_price : product.compare_at_price
          );
          if (compareCents > priceCents && compareCents > 0) {
            var compare = document.createElement('s');
            compare.textContent = formatMoney(compareCents);
            price.appendChild(compare);
          }
          price.appendChild(document.createTextNode(formatMoney(priceCents)));

          info.appendChild(name);
          info.appendChild(price);

          var action;
          if (canQuickAdd) {
            action = document.createElement('button');
            action.type = 'button';
            action.className = 'button button--secondary cart-drawer-related__action';
            action.textContent = addLabel;
            action.addEventListener(
              'click',
              function () {
                this.addToCart(variant.id, action);
              }.bind(this)
            );
          } else {
            action = document.createElement('a');
            action.className = 'button button--secondary cart-drawer-related__action';
            action.href = product.url || '/products/' + product.handle;
            action.textContent = chooseLabel;
          }

          item.appendChild(media);
          item.appendChild(info);
          item.appendChild(action);
          fragment.appendChild(item);
        }.bind(this)
      );

      this.list.innerHTML = '';
      this.list.appendChild(fragment);
    }

    addToCart(variantId, button) {
      var cart = document.querySelector('cart-drawer');
      if (!variantId || !cart || typeof cart.renderContents !== 'function') return;

      button.dataset.loading = '';
      button.disabled = true;

      var body = {
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: cart.getSectionsToRender().map(function (section) {
          return section.id;
        }),
        sections_url: window.location.pathname,
      };

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'add');
            return data;
          });
        })
        .then(function (data) {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-related',
              cartData: data,
            });
          }
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        })
        .catch(function () {
          button.disabled = false;
          delete button.dataset.loading;
        });
    }
  }

  customElements.define('cart-drawer-related', CartDrawerRelated);
})();
